import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiInputTextComponent } from './eui-input-text.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiInputTextComponent,
    ],
    exports: [
        EuiInputTextComponent,
    ],
})
export class EuiInputTextModule { }
